import React, { PureComponent } from 'react'
import { Redirect, Link } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Input,
  Layout,
  Form,
  Alert,
  Modal,
  message,
  Switch
} from 'antd';
import '@ant-design/compatible/assets/index.css'

import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Config from "../Config"; //'../../Config';
import { Helmet } from "react-helmet";

import { connect } from 'react-redux';
import {
  setConfig,
  ajaxHandler,
  ajaxViewHandler
} from "../store/actions"; //"../../store/actions";

import axios from 'axios';
import Cookies from 'js-cookie';
import QRCode from 'qrcode.react';

import $ from 'jquery'

import 'antd/dist/antd.css';

const configClass = {
  apiUrl: {
    cekLogin: "api/token/"
  }
}


class HeaderLayout extends PureComponent {
  config;
  // timeoutGetQr;
  // timeOutPushQr;

  constructor(props) {
    super(props);
    this.config = new Config();
    this.state = {
      msg: '',
      loading: false,
      loadingRedirect: false,
      logo: this.config.get_site_info().logo,
      isExpandAkun: false
    }
  }

  componentDidMount() {
    // setTimeout(function(){
    //     // document.getElementById("body").className('vertical-layout vertical-menu-modern 1-column  bg-lighten-2 blank-page login-page');
    //     document.body.setAttribute("data-open", "click");
    //     document.body.setAttribute("data-menu", "vertical-menu-modern");
    //     document.body.setAttribute("data-col", "1-column");
    // }, 3000);
    // var that = this;

    // $('.dropdown-user-link').click(function () {
    //   // alert('ok')
    //   var temp = that.state.isExpandAkun;
    //   that.setState({
    //     isExpandAkun: !temp
    //   })
    //   // alert('ok: '+temp)
    // });

  }

  // handleSubmit = (values) => {
  //   // values.preventDefault();
  //   // if(values.username == "admin" && values.password == "admin"){
  //   //   Cookies.set(this.config.get_cookie_name(), 'Bearer testing', { expires: 1 });
  //   //   this.setState({
  //   //     loading: false,
  //   //     loadingRedirect: true
  //   //   });
  //   //   setTimeout(() => {
  //   //       this.props.setConfig({
  //   //         isLogin: true
  //   //       });
  //   //   }, 3000);
  //   // }else{
  //   //   this.setState({
  //   //      msg: "username atau password salah"
  //   //   });
  //   // }
  //   this.postLogin(values);
  // }

  // doLoginPrototype(){
  //   Cookies.set(this.config.get_cookie_name(), 'Bearer testing', { expires: 1 });
  //   this.setState({
  //         loading: false,
  //         loadingRedirect: true
  //   });
  //   setTimeout(() => {
  //         this.props.setConfig({
  //           isLogin: true
  //         });
  //   }, 3000);
  // }

  // async postLogin(datas) {
  //   //message.loading({ content: 'Memproses...', duration: 2, key: 'toast' });
  //   this.setState({
  //     loading: true
  //   });

  //   this.props.ajaxHandler('post', configClass.apiUrl.cekLogin, datas, false, true, "login")
  //     .then(() => {
  //       this.setState({
  //         loading: false
  //       });
  //       if (this.props.isSuccess) {
  //         Cookies.set(this.config.get_cookie_name(), 'Bearer ' + this.props.responseMsg.access, { expires: 1 });
  //         this.setState({
  //           loading: false,
  //           loadingRedirect: true
  //         });
  //         setTimeout(() => {
  //           this.props.setConfig({
  //             isLogin: true
  //           });
  //         }, 3000);
  //       } else {
  //         this.setState({
  //           msg: this.props.responseMsg.access != undefined ? this.props.responseMsg.access : this.props.responseMsg
  //         });
  //       }
  //     }).catch((response) => {
  //       console.log('gagal_post', response);
  //       this.setState({
  //         loading: false
  //       });
  //       message.error({ content: 'kesalahan pengiriman data, code: ' + response.responseCode + 'coba lagi', duration: 2, key: 'toast' });
  //     });
  // }

  // logout() {
  //   Cookies.remove(this.config.get_cookie_name());
  //   //Cookies.remove('aBdi_d3s4uth_temp');
  //   this.props.setConfig({
  //     isLogin: false,
  //   });
  //   window.location.href = "/auth-internal"
  // }

  // pilihMode = e => {
  //   //console.log('radio3 checked', e.target.value);
  //   var mode = e ? 'prod' : 'dev';
  //   // localStorage.setItem('mode', theme);
  //   // this.props.setConfig({
  //   //   mode: theme
  //   // });

  //   Cookies.set("mode", mode);
  //   window.location.reload();
  // };

  // toggleAkun(){
  //   alert('yo')
  //   const temp = this.state.isExpandAkun;
  //   this.setState({
  //       isExpandAkun: !temp
  //   })

  // }

  render() {
    // if(this.props.isLogin){
    //   // return <Redirect to="/admin/index" />
    // }

    return (
      <nav
        className="header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-dark navbar-shadow navbar-brand-center">
        <div className="navbar-wrapper">
          <div className="navbar-header">
            <ul className="nav navbar-nav flex-row">
              <li className="nav-item mobile-menu d-md-none mr-auto"><a
                className="nav-link nav-menu-main menu-toggle hidden-xs" href="#"><i
                  className="ft-menu font-large-1"></i></a></li>
              <li className="nav-item"><a className="navbar-brand brand-web" href="javascript:;"><img className="brand-logo"
                alt="modern admin logo" src={process.env.PUBLIC_URL + "/assets/images/logo/logo-text-white.png"} /></a></li>
              <li className="nav-item"><a className="navbar-brand brand-mobile" href="javascript:;"><img className="brand-logo"
                alt="modern admin logo" src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"} />
                <h1 className="brand-text d-md-none text-bold-600" style={{ fontWeight: "600" }}>PUSAT DATA</h1>
              </a></li>
              <li className="nav-item d-md-none"><a className="nav-link open-navbar-container" data-toggle="collapse"
                data-target="#navbar-mobile"><i className="la la-ellipsis-v"></i></a></li>
            </ul>
          </div>
          <div className="navbar-container content">
            <div className="collapse navbar-collapse" id="navbar-mobile">
              <ul className="nav navbar-nav mr-auto float-left">
                <li className="nav-item d-none d-md-block"><a className="nav-link nav-menu-main menu-toggle hidden-xs"
                  href="#"><i className="ft-menu"></i></a></li>
                <li className="nav-item d-none d-lg-block"><a className="nav-link nav-link-expand" href="#"><i
                  className="ficon ft-maximize"></i></a></li>

              </ul>
              <ul className="nav navbar-nav float-right">
                {/* <li className="dropdown dropdown-language nav-item"><a className="dropdown-toggle nav-link tanggal-simlala"
                  id="dropdown-flag" href="#" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">25
                  April 2022</a>
                </li>
                <li className="dropdown dropdown-language nav-item"><a className="dropdown-toggle nav-link pembatas"
                  id="dropdown-flag" href="#" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">|</a>
                </li>
                <li className={this.state.isExpandAkun == true ? "dropdown dropdown-user nav-item show" : "dropdown dropdown-user nav-item"}><a
                  className="dropdown-toggle nav-link dropdown-user-link" href="#"
                  data-toggle="dropdown"><span className="mr-1 user-name text-bold-700" style={{ marginTop: "5px" }}>
                    {Cookies.get(this.config.get_cookie_name() + "_nama")}
                  </span></a>
                  <div className="dropdown-menu dropdown-menu-right"><a className="dropdown-item"
                    href="javascript:;"><i className="ft-settings"></i> User Setting</a>
                    <div className="dropdown-divider"></div><a className="dropdown-item"
                      href="javascript:;" onClick={() => this.logout()}><i className="ft-power"></i> Logout</a>
                  </div>
                </li> */}
              </ul>
            </div>
            <div className="brand-title d-none d-md-block">
              <h1 className="text-bold-600 white">PUSAT DATA</h1>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

const mapStateToProps = function (state) {
  return state.configReducers
}

export default connect(mapStateToProps,
  {
    setConfig,
    ajaxHandler,
    ajaxViewHandler
  }
)(HeaderLayout);
